import { render, staticRenderFns } from "./NormalReport.vue?vue&type=template&id=690215fd&"
import script from "./NormalReport.vue?vue&type=script&lang=ts&"
export * from "./NormalReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports